import { InputProps } from './types';

export const deleteQuotes = ({ value }: InputProps): string => {
  if (!value || typeof value !== 'string' || !value?.replaceAll) return '';

  return value.replaceAll('"', '');
};
